// ✅ NestedFieldConfigurator.tsx — Fixed and Enhanced
import React, { useState, useEffect } from "react";
import { useMultiLevelFieldsMutation, useDeleteMultiLevelFieldsMutation, useDeleteMultiLevelFieldsLabelMutation, useUpdateMultiLevelDynamicMutation, useUpdateLabelMultiLevelDynamicMutation } from '../../../../Services/settingsAPIs/CommonAPI';
import AddChoiceModal from './AddChoiceModal';
import EditChoiceModal from './EditChoiceModal';
import EditLabelModal from './EditLabelModal';
import AddSubLabelModal from './AddSubLabelModal';
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../../../common/DeleteConfirmationModal";
import DeleteLabelModal from "./DeleteLabelModel";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import ReactModal from "react-modal";
import { Field } from "formik";



// -------------------- Interfaces --------------------
interface MultiLevelField {
  id: string;
  label: string;
  level: number;
  parentId?: string;
  sub_fields?: MultiLevelField[];
  collapsed?: boolean;
  isNew?: boolean;
}

interface Props {
  fields: MultiLevelField[];
  onUpdate: (updatedFields: MultiLevelField[]) => void;
  fieldData: any;
  refetch?: () => Promise<any>;
  forceReopen?: () => void;
}

// -------------------- Component --------------------
const NestedFieldConfigurator: React.FC<Props> = ({
  fields,
  onUpdate,
  fieldData: initialFieldData,
  refetch,
  forceReopen,
}) => {
  const [addMultiLevelChoice, { isLoading: isAdding, error: addError }] = useMultiLevelFieldsMutation();
  const [deleteMultiLevelFields] = useDeleteMultiLevelFieldsMutation();
  const [deleteMultiLevelFieldsLabel] = useDeleteMultiLevelFieldsLabelMutation();
  const [updateMultiLevelDynamic, { isLoading: isUpdating }] = useUpdateMultiLevelDynamicMutation();
  const [updateLabelMultiLevelDynamic, { isLoading: isUpdatingLabel }] = useUpdateLabelMultiLevelDynamicMutation();
  // Modal state for sub-level label
  const [showSubLevelModal, setShowSubLevelModal] = useState(false);
  const [subLevelLabel, setSubLevelLabel] = useState('');
  const [subLevelFirstChoice, setSubLevelFirstChoice] = useState('');
  const [subLevelTarget, setSubLevelTarget] = useState<any>(null); // { fields, field, parentLabel }
  const [expandedNodes, setExpandedNodes] = useState<string[]>([]);

  // Add Choice Modal state
  const [showAddChoiceModal, setShowAddChoiceModal] = useState(false);
  const [addChoiceName, setAddChoiceName] = useState('');
  const [addChoiceParentId, setAddChoiceParentId] = useState<string | null>(null);
  const [addChoiceLevel, setAddChoiceLevel] = useState<number>(1);
  const [addChoiceFieldLabel, setAddChoiceFieldLabel] = useState<string>('');
  const [addChoiceError, setAddChoiceError] = useState('');
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDeleteLabelModel, setOpenDeleteLabelModel] = useState(false);
  const [deleteobject, setDeleteobject] = useState<any>({})
  const [deletelabel, setDeletelabel] = useState<any>({});
  // Use state for fieldData
  const [fieldData, setFieldData] = useState<any>(initialFieldData);
  console.log("fieldData", fieldData)

  useEffect(() => {
    setFieldData(initialFieldData);
  }, [initialFieldData]);

  // Edit modal state for editing a choice
  const [editModalState, setEditModalState] = useState<{
    show: boolean;
    value: string;
    error: string;
    idx?: number;
    fields?: any[];
    field?: any;
    parentLevelKey?: string;
  }>({ show: false, value: '', error: '' });

  // Edit modal state for editing a label
  const [editLabelModalState, setEditLabelModalState] = useState<{
    show: boolean;
    value: string;
    error: string;
    key?: string;
    firstIndex?: number;
    level?: number;
    id?: any;
    label?: any;
  }>({ show: false, value: '', error: '' });

  const deleteCustomModalStyles: ReactModal.Styles = {
    content: {
      top: "50%",
      left: "50%",
      width: "30%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const toggleNode = (id: string) => {
    setExpandedNodes((prev) =>
      prev.includes(id) ? prev.filter((n) => n !== id) : [...prev, id]
    );
  };

  // Ensure parent is notified on update
  const handleUpdate = (newData: any) => {
    setFieldData(newData);
    if (onUpdate) onUpdate(newData);
  };
  const closeModal = () => {
    setOpenDeleteModal(false);
  };
  const closeLabelModel = () => {
    setOpenDeleteLabelModel(false);
  };

  // useEffect(() => {
  //   if (addError) {
  //     console.log('Error:', addError);
  //     let errorMessage = 'An error occurred';

  //     // Handle different error formats
  //     if (addError && 'data' in addError && addError.data) {
  //       const errorData = addError.data as any;
  //       // Handle format: { "India": ["Field already exist"] }
  //       if (typeof errorData === 'object') {
  //         const errorKeys = Object.keys(errorData);
  //         if (errorKeys.length > 0 && Array.isArray(errorData[errorKeys[0]])) {
  //           errorMessage = errorData[errorKeys[0]][0];
  //         } else if (typeof errorData === 'string') {
  //           errorMessage = errorData;
  //         } else if (errorData.message) {
  //           errorMessage = errorData.message;
  //         }
  //       }
  //     } else if (typeof addError === 'string') {
  //       errorMessage = addError;
  //     } else if ('message' in addError && addError.message) {
  //       errorMessage = addError.message;
  //     }

  //     toast.error(errorMessage);
  //   }
  // }, [addError])

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
  };

  // Render choices from multiple_level as the visible text (e.g., India, china, USA)
  const renderFieldLevel = (fields: any[], parentLabel: string, parentId?: string, level: number = 1) => {
    const nodeKey = `${parentId || "root"}-level-${level}`;

    return (
      <div style={{
        marginTop: 8,
        padding: '10px 20px',
        background: '#f9fbfd',
        borderRadius: 8,
        boxShadow: '0 2px 8px #0001',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 60,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8, padding: '0 2px' }}>
          <div style={{ display: 'flex', alignItems: 'center', fontWeight: 700, marginBottom: 8, fontSize: 17, color: '#3a4251', padding: '0 2px', cursor: "pointer", gap: 10 }}
            onClick={() => toggleNode(nodeKey)}
          >
            <i
              className={`bi me-2 ${expandedNodes.includes(nodeKey)
                ? "bi-chevron-down"
                : "bi-chevron-right"
                }`}
            />
            {parentLabel}:
            {level !== 1 && (
              <>
                <button
                  type="button"
                  title="Edit Label"
                  aria-label="Edit Label"
                  style={{ background: 'none', border: 'none', padding: 0, marginLeft: 8, cursor: 'pointer' }}
                  onClick={(e) => {
                    e.stopPropagation();
                    // Get first field info at this level
                    const firstField = fields && fields.length > 0 ? fields[0] : {};
                    setEditLabelModalState({
                      show: true,
                      value: parentLabel,
                      error: '',
                      key: parentLabel,
                      firstIndex: 0,
                      level,
                      id: firstField.id,
                      label: firstField.field_label
                    });
                  }}
                >
                  <i className="text-dark ms-auto bi bi-pencil fs-4"></i>
                </button>
                <button type="button" title="Delete" aria-label="Delete" style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                  onClick={() => {
                    setOpenDeleteLabelModel(true);
                    setDeletelabel({ parentId, level });
                  }}
                ><i className="text-dark bi bi-trash fs-4 mx-1"></i></button>
              </>
            )}

          </div>
          <button
            type="button"
            title="Add Choice"
            aria-label="Add Choice"
            style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
            onClick={() => {
              setShowAddChoiceModal(true);
              setAddChoiceParentId(parentId || fieldData.id);
              setAddChoiceLevel(level);
              if (parentId) {
                // Find the parent in fields and get its first child's field_label
                const parent = fields.find(f => f.id === parentId);
                if (parent && parent.level2 && parent.level2.length > 0 && parent.level2[0].field_label) {
                  setAddChoiceFieldLabel(parent.level2[0].field_label);
                } else {
                  setAddChoiceFieldLabel(parentLabel);
                }
              } else {
                setAddChoiceFieldLabel(parentLabel);
              }
            }}
          >
            <i className="text-dark ms-auto bi bi-plus fs-1"></i>
          </button>
        </div>
        {expandedNodes.includes(nodeKey) && (
          <>
            {fields.map((field, idx) => (
              <div key={field.id || idx} style={{
                marginBottom: 12,
                background: '#fff',
                borderRadius: 8,
                boxShadow: '0 1px 4px #0001',
                padding: '16px',
                border: '1px solid #e3e7ed',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <input
                    type="text"
                    value={field.choice || ''}
                    disabled
                    style={{
                      marginRight: 8,
                      fontSize: 15,
                      padding: '6px 12px',
                      borderRadius: 4,
                      border: '1px solid #cfd8dc',
                      flex: 1,
                      background: '#f4f7fa',
                      color: '#222',
                      cursor: 'not-allowed',
                      opacity: 0.8
                    }}
                    placeholder={parentLabel + ' name'}
                  />
                  <button
                    type="button"
                    title="Edit"
                    aria-label="Edit"
                    style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                    onClick={() => {
                      // Find parent key and array for this field
                      let parentLevelKey = undefined;
                      let parentArray = fields;
                      if (Array.isArray(fields) && fields.length > 0 && fields[0].id !== field.id) {
                        // Try to find the parent level key by checking all keys in the parent object
                        const parent = fields.find(f => f.id === field.id);
                        if (!parent) {
                          // If not direct child, try to find the parent key in the parent object
                          const parentObj = fields.find(f => Object.values(f).some(val => Array.isArray(val) && val.includes(field)));
                          if (parentObj) {
                            parentLevelKey = Object.keys(parentObj).find(key => Array.isArray(parentObj[key]) && parentObj[key].includes(field));
                            parentArray = parentObj[parentLevelKey];
                          }
                        }
                      }
                      setEditModalState({
                        show: true,
                        value: field.choice || '',
                        error: '',
                        idx,
                        fields: parentArray,
                        field,
                        parentLevelKey
                      });
                    }}
                  >
                    <i className="text-dark ms-auto bi bi-pencil fs-4"></i>
                  </button>
                  <button type="button" title="Delete" aria-label="Delete" style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                    onClick={() => {
                      setOpenDeleteModal(true);
                      setDeleteobject({ nodeId: field.id, level });
                    }}
                  ><i className="text-dark bi bi-trash fs-4 mx-1"></i></button>
                  {level < 4 && (
                    <button type="button" title="Add Sub-Level" aria-label="Add Sub-Level" style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                      onClick={() => {
                        // Compute the current node's depth in the hierarchy



                        const levelKey = Object.keys(field).find(key => key.startsWith("level"));

                        const levelNumber = levelKey ? Number(levelKey.replace("level", "")) : null;
                        const nextLevelNumber = levelNumber || 2;

                        console.log("test", levelNumber, "Next level:", nextLevelNumber);
                        console.log("test", field);

                        setSubLevelTarget({
                          fields,
                          field,
                          parentLabel,
                          parentChoice: field.choice,
                          nextLevelNumber
                        });
                        setSubLevelLabel('');
                        setSubLevelFirstChoice('');
                        setShowSubLevelModal(true);
                      }}
                    ><i className="fas bi-plus cursor-pointer fs-1 text-dark mx-1"></i></button>
                  )}
                </div>
                {/* Sub-levels: Render all nested levels dynamically */}
                {Object.keys(field)
                  .filter(key => /^level\d+$/.test(key) && Array.isArray(field[key]) && field[key].length > 0 && field[key][0].field_label)
                  .map(levelKey => (
                    <div>

                      {renderFieldLevel(field[levelKey], field[levelKey][0].field_label, field.id, level + 1)}
                    </div>

                  ))}
              </div>
            ))}
          </>
        )}
        <div style={{ flex: '0 0 auto', marginTop: 16, display: 'flex', justifyContent: 'flex-start' }}>
          {/* <button
            type="button"
            title="Add Choice"
            aria-label="Add Choice"
            style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
            onClick={() => {
              setShowAddChoiceModal(true);
              setAddChoiceParentId(parentId || fieldData.id);
              setAddChoiceLevel(level);
              if (parentId) {
                // Find the parent in fields and get its first child's field_label
                const parent = fields.find(f => f.id === parentId);
                if (parent && parent.level2 && parent.level2.length > 0 && parent.level2[0].field_label) {
                  setAddChoiceFieldLabel(parent.level2[0].field_label);
                } else {
                  setAddChoiceFieldLabel(parentLabel);
                }
              } else {
                setAddChoiceFieldLabel(parentLabel);
              }
            }}
          ><i className="bi bi-plus-lg text-dark fs-4 mx-1"></i></button> */}

          <AddChoiceModal
            show={showAddChoiceModal}
            value={addChoiceName}
            error={addChoiceError}
            isLoading={isAdding}
            onChange={(val) => { setAddChoiceName(val); setAddChoiceError(''); }}
            onClose={() => { setShowAddChoiceModal(false); setAddChoiceName(''); setAddChoiceError(''); }}
            onSubmit={async () => {
              if (!addChoiceName.trim()) return;
              if (fields.some(f => f.choice?.toLowerCase() === addChoiceName.trim().toLowerCase())) {
                setAddChoiceError('Choice name must be unique');
                return;
              }
              console.log(addChoiceParentId, "test")
              const parentFieldId = addChoiceParentId || fieldData.id;

              const payload = {
                choice: addChoiceName.trim(),
                sort_order: 1,
                field_type: 'multi-level',
                field: parentFieldId,
                field_label: addChoiceFieldLabel,
                root_node: fieldData.id,
                level: addChoiceLevel
              };
              try {
                const response = await addMultiLevelChoice({ body: payload, level: addChoiceLevel }).unwrap();

                // Close modal
                setShowAddChoiceModal(false);
                setAddChoiceName('');
                setAddChoiceError('');

                // Optional: refetch backend to sync
                if (typeof refetch === 'function') {
                  await refetch();
                }
              } catch (error: any) {
                console.log('Add choice error:', error);
                let errorMessage = 'Failed to add choice';

                if (error?.data) {
                  // Handle format: { "India": ["Field already exist"] }
                  const errorData = error.data;
                  const errorKeys = Object.keys(errorData);
                  if (errorKeys.length && Array.isArray(errorData[errorKeys[0]])) {
                    errorMessage = errorData[errorKeys[0]][0];
                  } else if (typeof errorData === 'string') {
                    errorMessage = errorData;
                  } else if (errorData.message) {
                    errorMessage = errorData.message;
                  }
                }

                toast.error(errorMessage);
                setAddChoiceError(errorMessage);
              }
            }}
            disableAdd={!addChoiceName.trim() || fields.some(f => f.choice?.toLowerCase() === addChoiceName.trim().toLowerCase())}
          />
        </div>
      </div>
    );
  };

  const handleAddSubLevel = async () => {
    if (!subLevelTarget) return;
    const { fields, field, parentLabel, parentChoice, nextLevelNumber } = subLevelTarget;
    const payload = {
      choice: subLevelFirstChoice, // The first sub-level choice (e.g., 'Delhi')
      sort_order: 1,
      field_type: 'multi-level',
      field: field.id, // Parent node ID
      field_label: subLevelLabel, // The sub label (e.g., 'State', 'City', ...)
      root_node: fieldData.id, // Root node remains the same
      level: nextLevelNumber
    };
    try {
      const response = await addMultiLevelChoice({ body: payload, level: nextLevelNumber }).unwrap();

      // 4 Close modal & reset
      setShowSubLevelModal(false);
      setSubLevelLabel('');
      setSubLevelTarget(null);
      setSubLevelFirstChoice('');
      // 5 Optional: sync with backend
      if (typeof refetch === 'function') {
        await refetch();
      }
    } catch (error) {
      setAddChoiceError('Unknown error');
    }
  };

  return (
    <div>
      <EditLabelModal
        show={editLabelModalState.show}
        value={editLabelModalState.value}
        error={editLabelModalState.error}
        isLoading={false}
        labelName={editLabelModalState.key}
        onChange={val => setEditLabelModalState(s => ({ ...s, value: val, error: '' }))}
        onClose={() => setEditLabelModalState(s => ({ ...s, show: false, error: '' }))}
        onSubmit={async () => {
          try {
            if (!editLabelModalState.id || editLabelModalState.level === undefined) return;

            const response = await updateLabelMultiLevelDynamic({
              rootNode: fieldData.id,
              level: editLabelModalState.level,
              body: { field_label: editLabelModalState.value }
            }).unwrap();

            console.log('updateLabel API response:', response);

            if (!response) {
              throw new Error('No response from updateLabel API');
            }

            // 5) close modal and optionally refetch
            setEditLabelModalState(s => ({ ...s, show: false, error: '' }));

            if (typeof refetch === 'function') {
              await refetch();

            }
          } catch (error: any) {
            console.error('response:', error);
            setEditLabelModalState(s => ({ ...s, error: error?.data?.detail || 'Failed to update label' }));
          }
        }}
        disableSave={!editLabelModalState.value.trim()}
      />
      <EditChoiceModal
        show={editModalState.show}
        value={editModalState.value}
        error={editModalState.error}
        isLoading={isUpdating}
        onChange={val => setEditModalState(s => ({ ...s, value: val, error: '' }))}
        onClose={() => setEditModalState(s => ({ ...s, show: false, error: '' }))}
        onSubmit={async () => {
          if (!editModalState.fields || editModalState.idx === undefined || !editModalState.field) return;
          const updatedChoice = editModalState.value;
          const nodeId = editModalState.field.id;
          // Compute level for this node
          function findLevelById(node: any, targetId: any, currentLevel: number = 1): number | null {
            if (!node) return null;
            if (node.id === targetId) return currentLevel;
            if (currentLevel === 1 && Array.isArray(node.multiple_level)) {
              for (const child of node.multiple_level) {
                const found = findLevelById(child, targetId, currentLevel + 1);
                if (found !== null) return found;
              }
            }
            for (const key of Object.keys(node)) {
              if (/^level\d+$/.test(key) && Array.isArray(node[key])) {
                for (const child of node[key]) {
                  const found = findLevelById(child, targetId, currentLevel + 1);
                  if (found !== null) return found;
                }
              }
            }
            return null;
          }
          const level = findLevelById(fieldData, nodeId) - 1 || 1;
          try {
            const response = await updateMultiLevelDynamic({
              nodeId,
              level,
              body: { ...editModalState.field, choice: updatedChoice }
            }).unwrap();

            console.log('updateLabel API response:', response);

            if (typeof refetch === 'function') {
              await refetch();
            }
            setEditModalState(s => ({ ...s, show: false, error: '' }));
          } catch (err: any) {
            setEditModalState(s => ({ ...s, error: err?.data?.detail || 'Failed to update choice' }));
          }
        }}
        disableSave={!editModalState.value.trim()}
      />
      <AddSubLabelModal
        show={showSubLevelModal}
        value={subLevelLabel}
        error={''}
        isLoading={false}
        onChange={setSubLevelLabel}
        onClose={() => { setShowSubLevelModal(false); setSubLevelLabel(''); setSubLevelFirstChoice(''); }}
        onSubmit={handleAddSubLevel}
        disableAdd={!subLevelLabel.trim() || !subLevelFirstChoice.trim()}
        label={`Add Sub Label for ${subLevelTarget?.parentLabel || ''}`}
        parentChoice={subLevelTarget?.parentChoice || ''}
        subLevelFirstChoice={subLevelFirstChoice}
        onChangeSubLevelFirstChoice={setSubLevelFirstChoice}
      />

      {fieldData.field_type !== "multi-level" && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20, marginTop: 20, padding: "10px" }}>
          <input
            type="text"
            value={fieldData.label}
            onChange={e => {
              handleUpdate({ ...fieldData, label: e.target.value });
            }}
            style={{
              flex: 1,
              background: '#f4f7fa',
              border: '1px solid #cfd8dc',
              borderRadius: 4,
              padding: '7px 12px',
              fontSize: 15,
              color: '#222',
              outline: 'none',
            }}
          />
        </div>
      )}
      {renderFieldLevel(fieldData.multiple_level, fieldData.label || 'Choices')}

      <ReactModal
        isOpen={openDeleteModal}
        onRequestClose={closeModal}
        style={deleteCustomModalStyles}
        shouldCloseOnOverlayClick={false}

      >

        <DeleteConfirmationModal
          closeModal={closeModal} fieldsData={deleteobject} refetch={refetch}
          deleteMultiLevelFields={deleteMultiLevelFields}
          fieldData={fieldData}
          handleUpdate={handleUpdate}
        />
      </ReactModal>

      <ReactModal
        isOpen={openDeleteLabelModel}
        onRequestClose={closeLabelModel}
        style={deleteCustomModalStyles}
        shouldCloseOnOverlayClick={false}
      >
        <DeleteLabelModal
          closeModal={closeLabelModel} fieldsData={deletelabel} refetch={refetch}
          deleteMultiLevelFieldsLabel={deleteMultiLevelFieldsLabel}
          fieldData={fieldData}
          handleUpdate={handleUpdate}
        />
      </ReactModal>



    </div>
  )

};

export default NestedFieldConfigurator;
